// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Lovable Cloud publishable (anon) credentials — safe to ship in client bundle.
const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  'https://kmspvtgutdsecuinckpl.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imttc3B2dGd1dGRzZWN1aW5ja3BsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM4MzgzMjEsImV4cCI6MjA1OTQxNDMyMX0.T0TmKPQfe2Dsa7VpGsaq3sYxruP26vxiYXjFueOXKY8';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
